module.exports = __webpack_public_path__ + "static/service05-1816511d9ea2cd1b68163c1f5a0ddac9.png";